import {useTranslation} from "react-i18next";
import { v4 as uuidv4 } from 'uuid';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import SectionProgram from "./Program/SectionProgram";
import useEventProgram from "../../hooks/useEventProgram";

export default function UserProgram(
    {
        id
    }
) {
    const { t } = useTranslation();
    const [programData, dispatch] = useEventProgram(id);

    if (!programData) {
        return null;
    }

    const dateKeys = Object.keys(programData.program);
    const program = Object.values(programData.program);

    dateKeys.forEach((date, key) => {
        if (!Object.values(program[key]).some(section => {
            const elements = Object.values(section.elements);

            return elements.some(element => {
                return element.conferenceReport && programData.reports[element.conferenceReport.id].isUserSelected;
            });
        })) {
            delete dateKeys[key];
            delete program[key];
        }
    });

    return (
        <div
            className="tab-panel active"
            id="program">
            <p dangerouslySetInnerHTML={{__html: t('conferences.conference.myProgramCaption')}} />
            { !!dateKeys.length && <Tabs className="tabs-vertical">
                <div className="menu-scrollable">
                    <TabList className="nav-tabs-vertical">
                        {
                            dateKeys.map(
                                date => <Tab key={uuidv4()} selectedClassName="active">{ date }</Tab>
                            )
                        }
                    </TabList>
                </div>
                <div className="tabs-content-vertical">
                    { program.map(
                            sections => {
                                return (
                                    <TabPanel>
                                        <SectionProgram
                                            id={id}
                                            sections={sections}
                                            isUserSelectedOnly={true}
                                            reports={programData.reports}
                                            dispatch={dispatch}
                                        />
                                    </TabPanel>
                                );
                            }
                        )
                    }
                </div>
            </Tabs> }
        </div>
    );
}
